import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Stack, Drawer } from '@mui/material';
import { NAV } from '../../../config';
import Logo from '../../../components/logoApp/Logo';
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
//
import getNavConfig from './config';
import NavAccount from './NavAccount';
import { useSessionContext } from '../../../contexts/session/useSessionContext';

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { session } = useSessionContext();

  const { pathname } = useLocation();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          py: 2.5,
          flexShrink: 0,
        }}
      >
        <Logo disabledStyle />

        <NavAccount />
      </Stack>

      <NavSectionVertical data={getNavConfig(session)} />

      <Box sx={{ flexGrow: 1 }} />

    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >

        <Drawer
          anchor='right'
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
    </Box>
  );
}
